// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__389hF","questions":"styles_questions__H_TcB","footer":"styles_footer__2u2ZF"};